import { useTranslation } from "react-i18next";
import { cn } from "../../lib/utils";
import { Z_INDEX } from "../../lib/z-index";
import type { ColumnResizeHandleProps } from "./useColumnResize";

export interface TableColumnResizeHandleProps extends ColumnResizeHandleProps {
  label: string;
  share: number;
  isResizing: boolean;
}

export const TableColumnResizeHandle = ({ label, share, isResizing, ...handleProps }: TableColumnResizeHandleProps) => {
  const { t } = useTranslation();

  return (
    <div
      role="separator"
      aria-orientation="vertical"
      aria-label={t("Resize {{column}} column", { column: label })}
      aria-valuenow={Math.round(share)}
      aria-valuemin={0}
      aria-valuemax={100}
      tabIndex={0}
      data-slot="table-column-resize-handle"
      className={cn(
        "group/handle absolute inset-y-0 -right-1.5 w-3 cursor-col-resize touch-none select-none outline-none",
        // A resting divider so a resizable boundary is discoverable without hovering it first. It spans
        // the header's full height and darkens under the pointer.
        "after:absolute after:inset-y-0 after:left-1/2 after:w-px after:-translate-x-1/2 after:rounded-full",
        "after:bg-border after:transition-colors hover:after:bg-foreground/50 focus-visible:after:bg-ring",
        isResizing && "after:bg-primary",
        Z_INDEX.base
      )}
      {...handleProps}
    />
  );
};
